<template>
	<div class="tool-wrap">
		<Nav subNav="工具箱"></Nav>
		<div class="tool-body">
			<div class="back-wrap">
				<div class="back" @click="goClick">
					<div class="back-icon"></div>
					远程开机
				</div>
			</div>
			<div class="body-wrap" v-loading="isLoading">
				<div class="body-left">
					<div class="wakeup-success" v-if="isShowDone">
						已发送开机指令
					</div>

					<div class="empty-wrap" v-if="list.length <= 0">
						<div class="empty-icon"></div>
						<div class="empty-tips">请在右侧添加主机</div>
					</div>
					<div class="body-list" v-else>
						<WakeupItem
							@nameEditClick="nameEditClick"
							@removeServiceClick="removeServiceClick"
							@openClick="controlClick"
							:item="item"
							:key="item.mac"
							v-for="item in list"
						></WakeupItem>
					</div>
					<div class="left-help" @click="showNotWork">无法开机</div>
				</div>
				<div class="body-right">
					<div class="add-success" v-if="isShowAddSuccess">
						添加成功
					</div>
					<div class="add-title">添加设备</div>
					<div class="add-input">
						<input placeholder="请输入设备名称" v-model="name" />
					</div>
					<div class="add-input">
						<input placeholder="请输入MAC地址" v-model="mac" />
					</div>
					<div class="add-tips">{{ addTips }}</div>
					<div class="add-btn" @click="addClick">添加</div>
					<div class="tips-wrap">
						<div class="tips-title">
							<div class="tips-line-left"></div>
							<div class="tips-title-text">温馨提示</div>
							<div class="tips-line-right"></div>
						</div>
						<!-- <div class="tips-item">
							<div class="item-content">
								<p>前往高级服务</p>
								<p>添加Windows3389服务</p>
							</div>
							<div class="item-btn" @click="showAddHelp">
								如何添加
							</div>
						</div>
						<div class="tips-item-line"></div>
						<div class="tips-item">
							<div class="item-content">
								<p>开启该Windows主机</p>
								<p>WOL功能</p>
							</div>
							<div class="item-btn" @click="showOpenWol">
								如何开启
							</div>
						</div> -->

						<div class="tips-item2">
							<div class="item-content">
								<p>开机前请确认被唤醒主机</p>
								<p>支持并已开启WOL功能</p>
							</div>
							<div class="item-btn" @click="showOpenWol">
								如何开启
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<AddHelp @close="hideAddHelp" v-if="isShowAddHelp"></AddHelp>
		<NotWork @close="hideNotWork" v-if="isShowNotWork"></NotWork>
		<OpenWol @close="hideOpenWol" v-if="isShowOpenWol"></OpenWol>
	</div>
</template>

<script>
import Nav from "@/components/Common/Nav.vue";
import WakeupItem from "@/components/Wakeup/WakeupItem.vue";
import AddHelp from "@/components/Wakeup/AddHelp.vue";
import NotWork from "@/components/Wakeup/NotWork.vue";
import OpenWol from "@/components/Wakeup/OpenWol.vue";
import { mapActions } from "vuex";
import async from "async";
export default {
	components: {
		Nav,
		WakeupItem,
		AddHelp,
		NotWork,
		OpenWol,
	},
	data: function () {
		return {
			mac: "",
			name: "",
			addTips: "",
			isShowAddSuccess: false,
			isShowDone: false,
			isShowAddHelp: false,
			isShowNotWork: false,
			isShowOpenWol: false,
			list: [],
			devs: [],
			isLoading: false,
		};
	},
	watch: {
		addTips: function (newVal) {
			let _that = this;
			if (newVal) {
				setTimeout(function () {
					_that.addTips = "";
				}, 3000);
			}
		},
	},
	methods: {
		...mapActions([
			"bindget",
			"nodelist",
			"webWakeup",
			"addWakeup",
			"delWakeup",
			"getWakeups",
			"scan",
			"scanlist",
		]),
		showAddHelp: function () {
			this.isShowAddHelp = true;
		},
		hideAddHelp: function () {
			this.isShowAddHelp = false;
		},
		showNotWork: function () {
			this.isShowNotWork = true;
		},
		hideNotWork: function () {
			this.isShowNotWork = false;
		},
		showOpenWol: function () {
			this.isShowOpenWol = true;
		},
		hideOpenWol: function () {
			this.isShowOpenWol = false;
		},
		goClick: function () {
			this.$router.back(-1);
		},
		controlClick: function (item) {
			let _that = this;
			_that.wakeupMac(item.mac);
		},
		wakeupMac: function (mac) {
			let _that = this;
			let newMac = mac.replace(/\:/g, "");
			_that.bindget([
				function (err, data) {
					for (let index = 0; index < data.terms.length; index++) {
						const element = data.terms[index];
						_that.webWakeup([
							element.peerid,
							newMac,
							function () {},
						]);
					}

					_that.isShowDone = true;
					setTimeout(function () {
						_that.isShowDone = false;
					}, 3000);
				},
			]);
		},
		getList: function () {
			let _that = this;
			_that.getWakeups([
				function (err, data) {
					console.log(data);
					_that.list = data.data.list;
					_that.getDevs();
				},
			]);
		},
		addClick: function () {
			let _that = this;
			if (_that.name.length <= 0) {
				_that.addTips = "请输入设备名称";
				return;
			}
			if (_that.mac.length <= 0) {
				_that.addTips = "请输入MAC地址";
				return;
			}
			_that.mac = _that.mac.toUpperCase();
			_that.mac = _that.mac.replace(/：/g, ":");
			_that.mac = _that.mac.replace(/\ /g, "");
			if (_that.mac.indexOf(":") < 0) {
				_that.mac = _that.changeMac(_that.mac);
			}
			if (!_that.isMac(_that.mac)) {
				_that.addTips = "MAC地址错误";
				return;
			}

			_that.addWakeup([
				_that.mac,
				_that.name,
				function (err, data) {
					if (!err && data.rtn == 0) {
						_that.isShowAddSuccess = true;
						_that.name = "";
						_that.mac = "";
						_that.getList();
						setTimeout(function () {
							_that.isShowAddSuccess = false;
						}, 3000);
					}
				},
			]);
		},
		removeServiceClick: function (item, index) {
			let _that = this;
			_that.delWakeup([
				item.mac,
				function (err, data) {
					if (!err && data.rtn == 0) {
						_that.getList();
					}
				},
			]);
		},
		isMac: function (mac) {
			var temp =
				/[A-Fa-f0-9]{2}:[A-Fa-f0-9]{2}:[A-Fa-f0-9]{2}:[A-Fa-f0-9]{2}:[A-Fa-f0-9]{2}:[A-Fa-f0-9]{2}/;
			if (!temp.test(mac)) {
				return false;
			}
			return true;
		},
		nameEditClick: function (item) {
			let _that = this;
			item.mac = item.mac.toUpperCase();
			_that.addWakeup([
				item.mac,
				item.name,
				function (err, data) {
					if (!err && data.rtn == 0) {
						_that.getList();
					}
				},
			]);
		},
		getDevs: function (cb) {
			let _that = this;
			_that.isLoading = true;
			_that.bindget([
				function (err, data) {
					_that.devs = data.terms;
					_that.renderServices(function () {
						_that.renderNodeServices(function () {
							_that.isLoading = false;
							cb ? cb() : null;
						});
					});
				},
			]);
		},
		renderServices: function (cb) {
			let _that = this;
			let services = [];
			async.eachSeries(
				_that.devs,
				function (item, cb) {
					_that.scanServices(item, function (err, data) {
						for (let index = 0; index < data.length; index++) {
							const element = data[index];
							element.dev = item;
							// 离线电脑
							if (
								element.status &&
								element.dtype == 3 &&
								element.mac
							) {
								_that.checkAndAddList({
									type: "auto",
									name: element.name,
									mac: _that.changeMac(element.mac),
								});
							}
						}
						cb ? cb() : null;
					});
				},
				function () {
					cb ? cb() : null;
				}
			);
		},
		scanServices: function (dev, cb) {
			let _that = this;
			// let pidInfo = _that.$common.getInfoByPid(dev.peerid);
			// let mac = "";
			// if (dev.term && dev.term.nic && dev.term.nic.length > 0) {
			// 	mac = dev.term.nic[0].mac;
			// }
			_that.scan([
				dev.peerid,
				function (err, data) {
					let ready = data.ready;
					let timeoutSecond = ready ? 0 : 100;
					setTimeout(function () {
						//扫描服务
						_that.scanlist([
							dev.peerid,
							function (err, data) {
								let searchServiceList = [];
								if (data && !data.rtn && data.jd) {
									for (let i = 0; i < data.jd.length; i++) {
										let svs = data.jd[i].svs;
										// 过滤离线设备
										if (data.jd[i].status == 1) {
											continue;
										}
										if (data.jd[i].dtype) {
											//不显示没有类型的服务
											if (svs) {
												if (svs.length > 0) {
													for (
														let j = 0;
														j < svs.length;
														j++
													) {
														let item = JSON.parse(
															JSON.stringify(
																data.jd[i]
															)
														);
														item.ports = [
															svs[j].port,
														];
														item.port_name = svs[j]
															.name
															? svs[j].name
															: "";
														item.rule = svs[j].rule
															? svs[j].rule
															: 0;
														item.icon = svs[j].icon
															? svs[j].icon
															: "";
														item.button = svs[j]
															.button
															? svs[j].button
															: "";
														searchServiceList.push(
															item
														);
													}
												}
											} else {
												//没有端口
												if (data.jd[i].status == 1) {
													//仅添加离线的能够开机的设备
													searchServiceList.push(
														data.jd[i]
													);
												}
											}
										}
									}
									cb ? cb(null, searchServiceList) : null;
									return;
								} else {
									cb ? cb(null, searchServiceList) : null;
								}
							},
						]);
					}, timeoutSecond);
				},
			]);
		},
		renderNodeServices: function (cb) {
			let _that = this;
			//根据设备获取设备服务
			async.eachSeries(
				_that.devs,
				function (item, cb) {
					//设备
					let dev = JSON.parse(JSON.stringify(item));
					_that.nodelist([
						item.peerid,
						function (err, data) {
							if (!err && data.jd) {
								for (
									let index = 0;
									index < data.jd.length;
									index++
								) {
									const element = data.jd[index];
									// 离线电脑
									if (
										element.status &&
										element.dtype == 3 &&
										element.mac
									) {
										_that.checkAndAddList({
											type: "auto",
											name: element.name,
											mac: _that.changeMac(element.mac),
										});
									}
								}
							}

							cb ? cb() : null;
						},
					]);
				},
				function () {
					cb ? cb() : null;
				}
			);
		},
		changeMac: function (str) {
			let length = 2;
			var reg = new RegExp("\\w{1," + length + "}", "g");
			let ma = str.match(reg);
			return ma.join(":");
		},
		checkAndAddList: function (item) {
			let _that = this;
			for (let index = 0; index < _that.list.length; index++) {
				const element = _that.list[index];
				if (element.mac == item.mac) {
					return;
				}
			}
			_that.list.push(item);
		},
	},
	activated: function () {
		let _that = this;
		_that.getList();
	},
};
</script>
<style lang="less" scoped>
.tool-wrap {
	width: 100%;
	height: 100%;
	background-color: #f5f5f5;
}
.tool-body {
	margin: 0 auto;
	padding-top: 1px;
	width: 938px;
	height: 500px;
	box-sizing: border-box;
	border-radius: 4px;
	background-repeat: no-repeat;
	background-size: 100% 100%;
	background-color: #ffffff;
	border: 1px solid #dddddd;
	border-radius: 4px;

	.back-wrap {
		position: relative;
		width: 885px;
		margin: 0 auto;
		border-bottom: 1px solid #d4d9e5;
		.back {
			width: 150px;
			line-height: 48px;
			font-size: 14px;
			font-weight: 700;
			color: #1a1a1a;
			cursor: pointer;

			.back-icon {
				display: inline-block;
				margin-top: 15px;
				margin-right: 8px;
				vertical-align: top;
				width: 16px;
				height: 16px;
				background-image: url("../assets/device/infoBack.svg");
				background-repeat: no-repeat;
				background-size: 100% 100%;
			}
		}
	}

	.body-wrap {
		height: 418px;
		margin-top: 15px;
		.body-left {
			margin-left: 15px;
			width: 618px;
			height: 100%;
			display: inline-block;
			vertical-align: top;
			border-right: 1px solid rgba(194, 197, 202, 0.4);
			position: relative;

			.body-list {
				overflow-y: scroll;
				height: 100%;
			}

			.wakeup-success {
				width: 200px;
				height: 50px;
				line-height: 50px;
				text-align: center;
				font-weight: 600;
				font-size: 16px;
				color: #000000;
				position: absolute;
				top: 50%;
				left: 50%;
				margin-left: -73px;
				margin-top: -80px;
				background: #ffffff;
				box-shadow: 0px 0px 20px rgba(0, 26, 255, 0.1);
				border-radius: 8px;
				background-image: url(../assets/wakeup/done-icon.png);
				background-repeat: no-repeat;
				background-size: 25px 25px;
				background-position: 18px center;
				padding-left: 60px;
				text-align: left;
				box-sizing: border-box;
				z-index: 2;
			}

			.empty-wrap {
				.empty-icon {
					margin: 0 auto;
					margin-top: 140px;
					width: 142px;
					height: 101px;
					background-image: url(../assets/wakeup/empty.png);
					background-size: 100% 100%;
					background-repeat: no-repeat;
				}
				.empty-tips {
					margin-top: 20px;
					font-weight: 600;
					font-size: 16px;
					line-height: 22px;
					text-align: center;
					color: #1f1f1f;
				}
			}
			.left-help {
				position: absolute;
				right: 10px;
				bottom: 0px;
				background: #ffffff;
				border-radius: 120px;
				width: 112px;
				height: 42px;
				line-height: 42px;
				padding-left: 38px;
				filter: drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.1));
				box-sizing: border-box;
				background-image: url(../assets/wakeup/help.png);
				background-size: 24px 24px;
				background-position: 8px center;
				background-repeat: no-repeat;
			}
			.left-help:hover {
				cursor: pointer;
				opacity: 0.9;
			}
		}
		.body-right {
			width: 300px;
			height: 100%;
			display: inline-block;
			vertical-align: top;
			position: relative;

			.add-success {
				width: 146px;
				height: 50px;
				line-height: 50px;
				text-align: center;
				font-weight: 600;
				font-size: 16px;
				color: #000000;
				position: absolute;
				top: 50%;
				left: 50%;
				margin-left: -73px;
				margin-top: -80px;
				background: #ffffff;
				box-shadow: 0px 0px 20px rgba(0, 26, 255, 0.1);
				border-radius: 8px;
				background-image: url(../assets/wakeup/success-icon.png);
				background-repeat: no-repeat;
				background-size: 25px 25px;
				background-position: 18px center;
				padding-left: 55px;
				text-align: left;
				box-sizing: border-box;
			}
			.add-title {
				margin-top: 20px;
				font-weight: 500;
				font-size: 20px;
				line-height: 28px;
				text-align: center;
				color: #000000;
				text-align: center;
				margin-bottom: 24px;
			}
			.add-input {
				width: 228px;
				height: 42px;
				background: #fdfeff;
				border: 1px solid #e9ebed;
				box-shadow: 0px 2px 6px rgba(201, 206, 210, 0.16);
				border-radius: 86px;
				overflow: hidden;
				margin: 12px auto;
				input {
					width: 100%;
					height: 100%;
					line-height: 42px;
					text-align: center;
					font-weight: 400;
					font-size: 14px;
					text-align: center;
				}
			}
			.add-tips {
				text-align: center;
				color: red;
				font-size: 13px;
				margin-top: -5px;
				margin-bottom: -20px;
				height: 18px;
				line-height: 18px;
			}
			.add-btn {
				margin: 0 auto;
				margin-top: 24px;
				width: 228px;
				height: 42px;
				background: linear-gradient(
					276.72deg,
					#386abd -10.88%,
					#143977 81.54%
				);
				border-radius: 25px;

				font-weight: 600;
				font-size: 16px;
				line-height: 42px;
				text-align: center;
				color: #ffffff;
			}

			.add-btn:hover {
				cursor: pointer;
				opacity: 0.9;
			}

			.tips-wrap {
				background: rgba(244, 248, 253, 0.86);
				border-radius: 4px;
				width: 264px;
				height: 138px;
				margin: 0 auto;
				margin-top: 24px;
				padding-top: 1px;
				.tips-title {
					text-align: center;

					margin-top: 12px;
					.tips-line-left {
						display: inline-block;
						vertical-align: top;
						width: 74px;
						height: 3px;
						background-image: url(../assets/wakeup/tips-left.png);
						background-size: 100% 100%;
						margin-top: 8px;
					}
					.tips-title-text {
						display: inline-block;
						vertical-align: top;
						font-weight: 400;
						font-size: 14px;
						line-height: 20px;
						color: #1a1a1a;
						margin: 0 12px;
					}
					.tips-line-right {
						display: inline-block;
						vertical-align: top;
						width: 74px;
						height: 3px;
						background-image: url(../assets/wakeup/tips-right.png);
						background-size: 100% 100%;
						margin-top: 8px;
					}
				}

				.tips-item {
					margin-left: 20px;
					padding: 6px 0;
					.item-content {
						width: 176px;
						font-weight: 400;
						font-size: 12px;
						line-height: 18px;
						color: #666666;
						display: inline-block;
						vertical-align: top;
						p {
							line-height: 18px;
						}
					}
					.item-btn {
						width: 50px;
						height: 20px;
						display: inline-block;
						vertical-align: top;
						font-weight: 400;
						font-size: 12px;
						line-height: 20px;
						text-decoration-line: underline;
						color: #2f4386;
					}
					.item-btn:hover {
						cursor: pointer;
					}
				}
				.tips-item-line {
					background-color: rgba(168, 177, 205, 0.6);
					width: 226px;
					height: 1px;
					margin: 0 auto;
				}

				.tips-item2 {
					font-weight: 400;
					font-size: 12px;
					line-height: 17px;
					text-align: center;
					color: #666666;

					.item-content {
						margin-top: 15px;
					}

					.item-btn {
						width: 50px;
						height: 20px;
						font-weight: 400;
						font-size: 12px;
						line-height: 20px;
						text-decoration-line: underline;
						color: #2f4386;
						margin: 0 auto;
						margin-top: 20px;
					}
					.item-btn:hover {
						cursor: pointer;
					}
				}
			}
		}
	}
}
</style>